import type { SVGProps } from 'react';
const SvgTabletAndroid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#tablet_android_svg__a)">
      <path
        fill="currentColor"
        d="M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3Zm-4 22h-4v-1h4v1Zm5.25-3H4.75V3h14.5v16Z"
      />
    </g>
    <defs>
      <clipPath id="tablet_android_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTabletAndroid;
